import * as Sentry from '@sentry/browser'
import type { AxiosError } from 'axios'
import axios from 'axios'

export function handleAxiosError(error: AxiosError) {
  if (!error || axios.isCancel(error)) return

  if (!error.response) {
    Sentry.captureMessage('Axios Network Error', (scope) => {
      scope.setContext('error', {
        message: error.message,
        code: error.code,
      })

      return scope
    })
    ;(error as AxiosError & { __sentry_captured?: boolean }).__sentry_captured =
      true

    return
  }

  const { status } = error.response
  const { method, url, params, data, headers } = error.config || {}

  const normalizedUrl = url
    ?.split('?')[0]
    ?.replace(
      /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
      '/:uuid'
    )
    .replace(/\/[0-9a-f]{32}(?=[/\s?#]|$)/gi, '/:orderFormId')
    .replace(/\/\d+/g, '/:id')

  Sentry.captureException(error, (scope) => {
    scope.setTag('type', 'axios')
    scope.setTag('status', String(status))
    scope.setTag('method', String(method))
    scope.setContext('request', {
      url,
      method,
      params,
      data,
    })
    scope.setContext('response', {
      status,
      data: error.response?.data,
    })

    if (status === 431) {
      scope.setContext('headers-size', {
        cookieLength:
          typeof headers?.Cookie === 'string'
            ? headers.Cookie.length
            : undefined,
        authLength:
          typeof headers?.Authorization === 'string'
            ? headers.Authorization.length
            : undefined,
      })
    }

    scope.setFingerprint([
      'axios-error',
      String(method ?? ''),
      String(normalizedUrl ?? ''),
      String(status ?? ''),
    ])

    return scope
  })
  ;(error as AxiosError & { __sentry_captured?: boolean }).__sentry_captured =
    true
}
